export default __webpack_public_path__ + "static/ide2-a9ace3bbaaf735bbd673fce202ab6bcb.png";